import { createSlice } from "@reduxjs/toolkit";

import { setDeep } from "Libs/objectAccess";

import { getSubscriptionAlert, updateSubscriptionAlert } from "./thunks";

import type { SubscriptionAlertStateType } from "./types";

const initialState: SubscriptionAlertStateType = {
  data: {}
};

const subscriptionAlertSlice = createSlice({
  name: "app/organization/subscriptionAlert",
  initialState,
  reducers: {
    clearSubscriptionAlertError(state, action) {
      const { organizationDescriptionId, subscriptionId } = action.payload;

      if (state.data?.[organizationDescriptionId]?.[subscriptionId]) {
        setDeep(state, ["data", organizationDescriptionId, subscriptionId], {
          ...state.data[organizationDescriptionId]?.[subscriptionId],
          error: undefined
        });
      }
    }
  },
  extraReducers: builder => {
    // GET ORGANIZATION SUBSCRIPTION ALERT
    builder
      .addCase(getSubscriptionAlert.pending, (state, action) => {
        const { organizationDescriptionId, subscriptionId } = action.meta.arg;
        setDeep(
          state,
          ["data", organizationDescriptionId, subscriptionId, "loading"],
          "getting"
        );

        setDeep(
          state,
          ["data", organizationDescriptionId, subscriptionId, "error"],
          undefined
        );
      })
      .addCase(getSubscriptionAlert.fulfilled, (state, action) => {
        const { organizationDescriptionId, subscriptionId } = action.meta.arg;
        setDeep(state, ["data", organizationDescriptionId, subscriptionId], {
          alert: action.payload,
          loading: false,
          error: undefined
        });
      })
      .addCase(getSubscriptionAlert.rejected, (state, action) => {
        const { organizationDescriptionId, subscriptionId } = action.meta.arg;

        setDeep(
          state,
          ["data", organizationDescriptionId, subscriptionId, "loading"],
          false
        );

        setDeep(
          state,
          ["data", organizationDescriptionId, subscriptionId, "error"],
          action.payload
        );
      })
      // UPDATE ORGANIZATION SUBSCRIPTION ALERT
      .addCase(updateSubscriptionAlert.pending, (state, action) => {
        const { organizationDescriptionId, subscriptionId } = action.meta.arg;

        setDeep(
          state,
          ["data", organizationDescriptionId, subscriptionId, "loading"],
          "updating"
        );

        setDeep(
          state,
          ["data", organizationDescriptionId, subscriptionId, "error"],
          undefined
        );
      })
      .addCase(updateSubscriptionAlert.fulfilled, (state, action) => {
        const { organizationDescriptionId, subscriptionId } = action.meta.arg;

        setDeep(state, ["data", organizationDescriptionId, subscriptionId], {
          alert: action.payload,
          loading: false,
          error: undefined
        });
      })
      .addCase(updateSubscriptionAlert.rejected, (state, action) => {
        const { organizationDescriptionId, subscriptionId } = action.meta.arg;

        setDeep(
          state,
          ["data", organizationDescriptionId, subscriptionId, "loading"],
          false
        );

        setDeep(
          state,
          ["data", organizationDescriptionId, subscriptionId, "error"],
          action.payload
        );
      });
  }
});

export default subscriptionAlertSlice.reducer;

export const { clearSubscriptionAlertError } = subscriptionAlertSlice.actions;
